import { makeStyles } from "@mui/styles";
import { Bold, ExtraBold, Regular, SemiBold } from "../../utils";

export const useStyles = makeStyles((theme) => ({
    root: {
        border: "2px solid white",
        backgroundColor: "white",
        borderRadius: theme.palette.borderRadius,
        boxShadow: "0px 0px 16px #00000014",
        margin: "16px"
    },
    formTitle: {
        fontSize: "0.875rem",
        color: theme.typography.color.primary,
        fontFamily: ExtraBold
    },
    formBlock: {
        backgroundColor: "#FFFFFF",
        border: "1px solid #E4E8EE",
        position: "relative",
        // height: "100vh"
    },
    componentBox: {
        border: "1px solid #E4E8EE",
        borderRadius: theme.palette.borderRadius,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px",
        cursor: "pointer",
        "&:hover": {
            border: "1px solid #5078E1",
            borderRadius: theme.palette.borderRadius,
            backgroundColor: "#F1F7FF"
        }
    },
    viewcomponentBox: {
        border: "1px solid #E4E8EE",
        borderRadius: theme.palette.borderRadius,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px",
        cursor: "not-allowed",
    },
    formComponentTitle: {
        fontSize: "0.875rem",
        color: theme.typography.color.primary,
        fontFamily: Bold,
        marginTop: "12px",
        textAlign: "center"


    },
    fixedBottom: {
        border: "1px solid #E4E8EE",
        display: "flex",
        justifyContent: "space-between",
        padding: "12px",
        bottom: 0,
        left: 0,
        right: 0,
        position: "absolute",
        [theme.breakpoints.down('md')]: {
            display: "block"
        }


        // marginTop: "80px",
    },
    nocomponentText: {
        fontSize: "0.875rem",
        fontFamily: Bold,
        color: theme.typography.color.secondary
    },
    choosecomponentText: {
        fontSize: "0.75rem",
        fontFamily: Regular,
        color: theme.typography.color.secondary
    },
    nocomponentBox: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        // padding: "70px 0px",
        textAlign: "center",
        // [theme.breakpoints.down('md')]: {
        //     padding: "40px 0px",
        // }


    },
    chooseQuestions: {
        margin: "20px 40px",
        borderRadius: theme.palette.borderRadius,
        boxShadow: "0px 0px 16px #00000014",
        backgroundColor: "#FFFFFF"
    },
    dragIcon: {
        border: "1px solid #E4E8EE",
        borderRadius: theme.palette.borderRadius,
        padding: '1px',
        display: "flex",
        justifyContent: "center",
        cursor: "move"
    },
    customSelectBox: {
        padding: "2px",
        border: "1px solid #E4E8EE",
        borderRadius: theme.palette.borderRadius,
        width: "180px"
    },
    optionsText: {
        fontSize: "0.75rem",
        fontFamily: SemiBold,
        color: theme.typography.color.primary,
        marginLeft: "5px"
    },
    questiontxt: {
        fontSize: "0.75rem",
        fontFamily: SemiBold,
        color: theme.typography.color.tertiary,
    },
    rightBlock: {
        
        overflow: "scroll",
        position: "relative",
        [theme.breakpoints.down('md')]: {
            height: `calc(100vh - 150px)`,
        }


    },
    optiontitle: {
        fontSize: "0.75rem",
        fontFamily: Bold,
        color: theme.typography.color.secondary,
        textTransform: "uppercase"
    },
    addAnother: {
        fontFamily: Bold,
        fontSize: "0.75rem",
        color: "#5078E1",
        cursor: "pointer"
    },
    draftbtn: {
        "&:hover": { backgroundColor: "white" }
    },
    goBacktext: {
        fontSize: "1.125rem",
        color: theme.typography.color.primary,
        fontFamily: Bold
    },
    goBackSubtxt: {
        fontSize: "0.875rem",
        fontFamily: Regular,
        color: theme.typography.color.secondary
    },
    viewQuestionhdr: {
        fontSize: "0.875rem",
        color: theme.typography.color.primary,
        fontFamily: SemiBold,
        textTransform: "capitalize"
    },
    rating: {
        border: "1px solid #E4E8EE",
        borderRadius: theme.palette.borderRadius,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "3px",
        width: "32px",
        height: "32px"
    },
    selectedRating: {
        backgroundColor: "#F1F7FF",
        border: "1px solid #5078E1",
        borderRadius: theme.palette.borderRadius,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "3px",
        width: "32px",
        height: "32px"
    },
    bottomDiv: {
        padding: "16px",
        border: "1px solid #E4E8EE",
        // position:"absolute",
        // bottom:0,
        left: 0,
        right: 0
    },
    formCategory: {
        padding: "16px 16px 0px 16px"
    },
    question_bank: {
        padding: "8px 16px 0px 16px",
        position: "relative"
    },
    iconButton: {
        borderRadius: "4px",
        border: `1px solid ${theme.palette.border.primary}`,
        height: '40px',
        width: '40px'
    },
    responsiveBlock: {
        [theme.breakpoints.down('md')]: {
            height: `calc(100vh - 275px)`,
            overflow: "scroll"
        }
    },
    tabtitle1: {
        fontSize: "0.75rem",
        color: theme?.palette?.primary?.main,
        fontFamily: Bold,
        marginInlineStart: "7px",
    },
    tab: {
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
      },
    selectBack1: {
        backgroundColor: theme?.palette?.info?.light ?? "",
        display: "flex",
        alignItems: "center",
        padding: "14px 20px",
        position: "relative",
    },
    selectBack: {
        display: "flex",
        alignItems: "center",
        padding: "14px 20px",
        backgroundColor: "white",
    },
    next: {
        marginInlineStart: "8px",
        fontFamily: SemiBold,
        color: "white",
        backgroundColor: theme?.typography?.status?.primary ?? "",
        "&:hover": {
          backgroundColor: theme?.typography?.status?.primary ?? "",
        },
      },
      Cancel: {
        backgroundColor: theme?.typography?.color?.white ?? "",
        color: theme?.typography?.color?.primary ?? "",
        fontSize:"0.875rem",
        fontWeight: 600,
        fontFamily: SemiBold,
        border: `1px solid ${theme?.palette?.border?.secondary}`,
        marginRight: "8px",
        "&:hover": {
          backgroundColor: theme?.typography?.color?.white ?? "",
        },
      },
      bottombtn: {
        padding: "11px 16px",
        backgroundColor: "white",
        boxShadow: "0px 0px 16px #00000014",
        display: "flex",
        justifyContent: "space-between",
        border: `1px solid ${theme?.palette?.border?.secondary}`,
        position: "sticky",
        bottom: "0px",
        width: "100%",
        zIndex: 2,
      },
      tabtitle: {
        fontSize:"0.75rem",
        color: theme?.typography?.color?.secondary ?? "",
        fontFamily: Bold,
        marginInlineStart: "7px",
      },
      roleRoot: {
        padding: "16px",
        overflow: ({ size }) => (size?.width <= 899 && size?.height <= 850) && "overlay",
        height: ({ size }) => (size?.width <= 899 && size?.height <= 850) && `calc(100vh - 230px)`,
      },
      Feedbackrepliesroot: {
        border: "2px solid white",
        backgroundColor: "white",
        borderRadius: theme.palette.borderRadius,
        boxShadow: "0px 0px 16px #00000014",
        padding: "16px",
        margin:"16px"
    },
}))